<template>
    <div class="modal" tabindex="-1" role="dialog" id="c2b-subscriber-specific-modal">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="float-left">
                        <h5 class="modal-title">Detalhes do cliente</h5>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12 col-md-6 form-group">
                            <label>Cliente</label>
                            <p>{{subscriber.realName}}</p>
                            <small class="text-muted mb-0">{{subscriber.name}}</small>
                            <br>
                            <small class="text-muted mb-0">{{subscriber.alias}}</small>
                        </div>

                        <div class="col-12 col-md-3 form-group">
                            <label>CNPJ</label>
                            <p>{{subscriber.document | infoOrPlaceholder}}</p>
                        </div>

                        <div class="col-12 col-md-3 form-group">
                            <label>Código CRM</label>
                            <p>{{subscriber.idExternal | infoOrPlaceholder}}</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 form-group">
                            <label>Email</label>
                            <p class="mb-0" v-for="(email, index) in subscriber.getAddress().getEmailList()" :key="index">{{email | infoOrPlaceholder}}</p>
                        </div>
                        <div class="col-12 col-md-3 form-group">
                            <label>Celular</label>
                            <p>{{subscriber.getAddress().cellPhone | infoOrPlaceholder}}</p>
                        </div>
                        <div class="col-12 col-md-3 form-group">
                            <label>Telefone</label>
                            <p>{{subscriber.getAddress().phone | infoOrPlaceholder}}</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-3 form-group">
                            <label>CEP</label>
                            <p>{{subscriber.getAddress().postalCode | infoOrPlaceholder}}</p>
                        </div>
                        <div class="col-12 col-md-6 form-group">
                            <label>Logradouro</label>
                            <p>
                                <span>{{subscriber.getAddress().street}}</span>
                                <span v-show="!!subscriber.getAddress().number">, {{subscriber.getAddress().number}}</span>
                            </p>
                        </div>
                        <div class="col-12 col-md-3 form-group">
                            <label>Bairro</label>
                            <p>{{subscriber.getAddress().neighborhood | infoOrPlaceholder}}</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-3 form-group">
                            <label>Complemento</label>
                            <p>{{subscriber.getAddress().complement | infoOrPlaceholder}}</p>
                        </div>

                        <div class="col-12 col-md-6 form-group">
                            <label>Cidade</label>
                            <p>{{subscriber.getAddress().city}}/{{subscriber.getAddress().state}}</p>
                        </div>
                    </div>

                    <div class="subscriber-product-info" v-for="(subscriberProduct, productIndex) in subscriber.products" :key="productIndex">
                        <div class="row">
                            <div class="col-12 col-md-3 form-group">
                                <label>Produto</label>
                                <p>{{subscriberProduct.product.name}}</p>
                            </div>

                            <div class="col-12 col-md-3 form-group">
                                <label>Cadastrado em</label>
                                <p>{{subscriberProduct.createdAt | dateFilter}}</p>
                            </div>

                            <div class="col-12 col-md-3 form-group">
                                <label>Status</label>
                                <p>
                                    <span class="badge badge-success" v-show="subscriberProduct.isActive">Ativo</span>
                                    <span class="badge badge-secondary" v-show="!subscriberProduct.isActive">Inativo</span>
                                </p>
                            </div>

                            <div class="col-12 col-md-3 form-group">
                                <label>Cobrança</label>
                                <p>
                                    <span class="badge badge-success" v-show="subscriberProduct.billingEnabled">Ativa</span>
                                    <span class="badge badge-secondary" v-show="!subscriberProduct.billingEnabled">Inativa</span>
                                </p>
                            </div>
                        </div>

                        <div class="row">                                   
                            <div class="col-12 col-md-6 form-group">
                                <label>Contrato aceito por</label> 
                                <p class="mb-0" v-for="(agreement, agreementIndex) in subscriberProduct.agreements" :key="agreementIndex">
                                    <span>{{agreement.getUserInfo() | infoOrPlaceholder}}</span>
                                </p>
                                <p v-show="!subscriberProduct.agreements.length">-</p>
                            </div>

                            <div class="col-12 col-md-6 form-group">
                                <label>Contrato aceito em</label> 
                                <p class="mb-0" v-for="(agreement, agreementIndex) in subscriberProduct.agreements" :key="agreementIndex">{{agreement.dateAccept | dateFilter | infoOrPlaceholder}}</p>
                                <p v-show="!subscriberProduct.agreements.length">-</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-md-6 form-group">
                                <label>Vendedor</label>
                                <p>{{subscriberProduct.seller.realName | infoOrPlaceholder}}</p>
                                <small class="text-muted">{{subscriberProduct.seller.idExternal | infoOrPlaceholder}}</small>
                            </div>

                            <div class="col-12 col-md-6 form-group">
                                <label>Schema</label>
                                <p>{{subscriberProduct.schemaName | infoOrPlaceholder}}</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-md-3 form-group">
                                <label>Primeira cobrança</label>
                                <p v-show="subscriberProduct.hasFirstBilling()">{{subscriberProduct.firstBilling.dueDate | dateFromStringFilter}} ({{subscriberProduct.firstBilling.total | currency}})</p>
                                <p v-show="!subscriberProduct.hasFirstBilling()">-</p>
                            </div>

                            <div class="col-12 col-md-3 form-group">
                                <label>Segunda cobrança</label>
                                <p v-show="subscriberProduct.hasSecondBilling()">{{subscriberProduct.secondBilling.dueDate | dateFromStringFilter}} ({{subscriberProduct.secondBilling.total | currency}})</p>
                                <p v-show="!subscriberProduct.hasSecondBilling()">-</p>
                            </div>

                            <div class="col-12 col-md-3 form-group">
                                <label>Tabela de preço</label>
                                <p>{{subscriberProduct.price.name | infoOrPlaceholder}}</p>
                            </div>

                            <div class="col-12 col-md-3 form-group" v-show="subscriberProduct.hasBeenCanceled()">
                                <label>Cancelado</label>
                                <p>{{subscriberProduct.canceledAt | dateFilter}}</p>
                            </div>
                        </div>              

                        <div class="row">
                            <div class="col-12 mt-2 form-group" v-show="userAuthenticated.hasRoleAdmin() || userAuthenticated.hasRoleOperator()">
                                <button type="button" 
                                    class="btn btn-outline-secondary btn-sm" 
                                    :disabled="updatingBillingStatus"
                                    v-show="!subscriberProduct.billingEnabled"
                                    @click="enableBilling(subscriber, subscriberProduct.product)">
                                    Habilitar cobrança

                                    <Loading v-show="updatingBillingStatus" />
                                </button>

                                <button type="button" 
                                    class="btn btn-outline-secondary btn-sm" 
                                    :disabled="updatingBillingStatus"
                                    v-show="subscriberProduct.billingEnabled"
                                    @click="disableBilling(subscriber, subscriberProduct.product)">
                                    Paralisar cobrança

                                    <Loading v-show="updatingBillingStatus" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" 
                        class="btn btn-outline-secondary" 
                        @click="closeSpecificSubscriberModal()">Fechar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ModalService from '../../utils/services/ModalService'
import { SubscriberModel } from '../models/SubscriberModel'
import subscriberService from '../services/SubscriberService'
import { dateFilter, dateFromStringFilter } from '@/utils/filters/DateTimeFilter'
import { infoOrPlaceholder } from '@/utils/filters/InformationOrPlaceholderFilter'
import { mapState } from 'vuex'

const ID_SUBSCRIBER_SPECIFIC_MODAL = '#c2b-subscriber-specific-modal'

export default {
    name: 'SubscriberSpecificCmp',
    filters: {
        dateFilter,
        dateFromStringFilter,
        infoOrPlaceholder,
    },
    data() {
        return {
            updatingBillingStatus: false,
            subscriber: new SubscriberModel(),
        }
    },
    methods: {
        async openModal(id) {
            try {
                this.subscriber = await subscriberService.getSubscriberById(id)
                return ModalService.show(ID_SUBSCRIBER_SPECIFIC_MODAL)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }
        },
        closeSpecificSubscriberModal() {
            ModalService.hide(ID_SUBSCRIBER_SPECIFIC_MODAL)
        },
        async enableBilling(subscriber, product) {
            this.updatingBillingStatus = true;

            try {
                this.subscriber = await subscriberService.enableBilling(subscriber.id, product.id)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.updatingBillingStatus = false;
        },
        async disableBilling(subscriber, product) {
            this.updatingBillingStatus = true;

            try {
                this.subscriber = await subscriberService.disableBilling(subscriber.id, product.id)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.updatingBillingStatus = false;
        },
    },
    computed: {
        ...mapState({
            userAuthenticated: state => state.userAuthenticated,
        })
    },
}
</script>

<style lang="scss" scoped>
.subscriber-product-info {
    margin: 0 -15px;
    padding: 8px 15px 0;
    margin-bottom: 16px;
    border-top: 1px dashed #dee1e3;
    border-bottom: 1px dashed #dee1e3;
    background-color: #f9f9fa;

    &:last-of-type {
        margin-bottom: 0;
    }
}
</style> 